import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from "react-router-dom";

const PermissionWrapper = ({ requiredPermissions, children }) => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const hasPermission = requiredPermissions.every(permission => 
    auth.permissions?.includes(permission)
  );

  // Si no tiene permisos, no muestra el componente
  /*
  if(auth.permissions.lenght == 0){
    setPermissions({ permissions: [] });
    navigate("/");
  }
  useEffect(()=>{
    console.log("hasPermission",hasPermission);
    if(!hasPermission){
      navigate('/app'); 
    }
  },[hasPermission]);
  */

  if (!hasPermission) return null;

  return <>{children}</>;
};

export default PermissionWrapper;